export function safeDecodeSlug(input = "") {
  try {
    const maybeDecoded = /%[0-9a-f]{2}/i.test(input)
      ? decodeURIComponent(input)
      : input
    return maybeDecoded.normalize("NFC")
  } catch {
    return input
  }
}
